<template>
  <div class="forgot-password-container">
    <!-- Animated Vibrant Blobs -->
    <div class="bg-blobs">
      <div class="blob blob-orange"></div>
      <div class="blob blob-peach"></div>
      <div class="blob blob-blue"></div>
      <div class="blob blob-gold"></div>
    </div>

    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    
    <!-- Snackbar for notifications -->
    <v-snackbar 
      v-model="snackbar" 
      color="#ff6f3c" 
      right 
      :timeout="3000"
      class="custom-snackbar"
    >
      <div class="d-flex align-center justify-space-between w-100 py-1">
        <span class="snackbar-text">{{ msg }}</span>
        <v-btn icon small @click="snackbar = false" class="close-snack-btn">
          <v-icon color="white" small>mdi-close</v-icon>
        </v-btn>
      </div>
    </v-snackbar>

    <!-- Card -->
    <div class="unified-card">
      <!-- Brand Logo -->
      <div class="logo-container">
        <!-- Logo 1: SARPA -->
        <div class="logo-row mb-3">
          <img
            :src="require('../../assets/sarpamp.png')"
            alt="SARPA - MP"
            class="sarpa-icon"
          />
          <span class="logo-text">SARPA <span class="accent-text">MP</span></span>
        </div>
        
        <!-- Logo 2: Government -->
        <div class="logo-row mb-6">
          <img
            :src="require('../../assets/mpgovernment.png')"
            alt="GOVERNMENT OF MP"
            class="gov-icon"
          />
          <span class="logo-text gov-text">GOVERNMENT OF MP</span>
        </div>
      </div>

      <!-- Header -->
      <div class="card-header text-center">
        <h2 class="card-title">Forgot Password?</h2>
        <div class="accent-line"></div>
        <p class="card-description">
          Enter your Username and Phone number and we'll send you an OTP to reset your password.
        </p>
      </div>

      <!-- Form -->
      <div class="form-container">
        <!-- Username Input -->
        <div class="input-group mb-4">
          <label class="input-label">User Name</label>
          <v-text-field
            outlined
            dense
            v-model="userName"
            placeholder="Enter your Username"
            class="custom-text-field"
            hide-details
            prepend-inner-icon="mdi-account"
          ></v-text-field>
        </div>

        <!-- Phone Number Input -->
        <div class="input-group mb-6">
          <label class="input-label">Phone Number</label>
          <v-text-field
            outlined
            dense
            v-model="phone"
            placeholder="Enter your Phone Number"
            class="custom-text-field"
            hide-details
            prepend-inner-icon="mdi-phone"
          ></v-text-field>
        </div>

        <!-- Submit Button -->
        <v-btn 
          block 
          class="submit-btn mb-4"
          @click="sentOTP()"
          height="48"
          depressed
        >
          <span class="btn-text">Submit</span>
        </v-btn>

        <!-- Back to Login -->
        <div class="back-to-login text-center">
          <span class="back-text">Back to </span>
          <router-link to="/login" class="login-link">Login</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      snackbar: false,
      timeout: 5000,
      msg: null,
      phone: null,
      userName: "",
      status: "",
    };
  },
  methods: {
    sentOTP() {
      if (!this.userName || !this.userName.trim()) {
        this.msg = "Please enter your username.";
        this.snackbar = true;
        return;
      }
      if (!this.phone) {
        this.msg = "Please enter your phone number.";
        this.snackbar = true;
        return;
      }
      const phonePattern = /^\d{10}$/;
      if (!phonePattern.test(this.phone)) {
        this.msg = "Please enter a valid 10-digit phone number.";
        this.snackbar = true;
        return;
      }

      var userData = {};
      userData["phone"] = this.phone;
      userData["userName"] = this.userName;
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/users/resetotp/password/Officials",
        data: userData,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.status = response.data.status;
            this.msg = "OTP Sent Successfully";
            this.$router.push({ path: "/resetPassword", query: { phone: this.phone, userName: this.userName } });
            this.snackbar = true;
          } else {
            this.msg = response.data.msg;
            this.snackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.forgot-password-container {
  position: relative;
  min-height: 100vh !important;
  width: 100%;
  overflow: hidden !important;
  background: radial-gradient(circle at 10% 10%, #241108 0%, #0c0806 50%, #030202 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'sofiaProRegular', sans-serif;
  padding: 24px;
  margin: 0;
}

/* Background Blobs */
.bg-blobs {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;
}

.blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.35;
  animation: float 25s infinite alternate ease-in-out;
  will-change: transform;
}

.blob-orange {
  background: rgba(255, 111, 60, 0.25);
  width: 400px;
  height: 400px;
  top: -8%;
  left: -5%;
  animation-duration: 26s;
}

.blob-peach {
  background: rgba(255, 207, 184, 0.2);
  width: 480px;
  height: 480px;
  bottom: -12%;
  right: -8%;
  opacity: 0.25;
  animation-duration: 32s;
  animation-delay: -5s;
}

.blob-blue {
  background: rgba(37, 99, 235, 0.12);
  width: 380px;
  height: 380px;
  top: 20%;
  right: 15%;
  opacity: 0.15;
  animation-duration: 28s;
  animation-delay: -7s;
}

.blob-gold {
  background: rgba(234, 179, 8, 0.15);
  width: 320px;
  height: 320px;
  top: 45%;
  left: 45%;
  opacity: 0.2;
  margin-top: -160px;
  margin-left: -160px;
  animation-duration: 20s;
  animation-delay: -10s;
}

@keyframes float {
  0% {
    transform: translate3d(0px, 0px, 0px);
  }
  33% {
    transform: translate3d(20px, -30px, 0px);
  }
  66% {
    transform: translate3d(-10px, 10px, 0px);
  }
  100% {
    transform: translate3d(0px, 0px, 0px);
  }
}

.unified-card {
  width: 100%;
  max-width: 440px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(255, 245, 240, 0.97) 100%);
  border: 1px solid rgba(255, 111, 60, 0.25);
  border-radius: 24px;
  padding: 36px 32px;
  box-shadow: 
    0 15px 35px rgba(34, 17, 12, 0.06),
    0 30px 60px rgba(0, 0, 0, 0.12);
  z-index: 1;
}

/* Logo styling */
.logo-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 12px;
  width: 100%;
}

.logo-row {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 12px;
}

.sarpa-icon {
  width: 32px !important;
  height: 32px !important;
  object-fit: contain;
  flex-shrink: 0;
}

.gov-icon {
  width: 64px !important;
  height: 64px !important;
  object-fit: contain;
  flex-shrink: 0;
  margin-left: -10px !important;
  margin-right: -10px !important;
}

.logo-text {
  font-family: 'sofiaProSemiBold', sans-serif;
  font-size: 17px;
  font-weight: 700;
  color: #000000;
  letter-spacing: 0.5px;
}

.logo-text .accent-text {
  color: #FF7722;
}

.gov-text {
  font-size: 17px;
  color: #000000;
  font-family: 'sofiaProSemiBold', sans-serif;
  font-weight: 700;
}

/* Header styling */
.card-header {
  margin-bottom: 24px;
}

.card-title {
  font-family: 'sofiaProSemiBold', sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: #22110c;
  margin-bottom: 6px;
  letter-spacing: -0.5px;
}

.accent-line {
  width: 40px;
  height: 4px;
  background: linear-gradient(90deg, #ff6f3c 0%, #ffcfb8 100%);
  border-radius: 2px;
  margin: 0 auto 12px auto;
}

.card-description {
  font-family: 'sofiaProRegular', sans-serif;
  font-size: 13.5px;
  color: #665551;
  line-height: 1.4;
  text-align: center;
}

/* Form inputs & label */
.input-group {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.input-label {
  font-family: 'sofiaProMedium', sans-serif;
  font-size: 13px;
  color: #3d2d2a;
  margin-bottom: 6px;
  font-weight: 500;
}

/* Submit button */
.submit-btn {
  background: linear-gradient(135deg, #ff6f3c 0%, #c43d0e 100%) !important;
  border-radius: 12px !important;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
}

.submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 111, 60, 0.3) !important;
  background: linear-gradient(135deg, #ff8c52 0%, #ff6f3c 100%) !important;
}

.btn-text {
  font-family: 'sofiaProSemiBold', sans-serif;
  font-size: 14.5px;
  color: #ffffff !important;
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0.5px;
}

/* Back to login */
.back-to-login {
  margin-top: 12px;
}

.back-text {
  font-family: 'sofiaProRegular', sans-serif;
  font-size: 14px;
  color: #665551;
}

.login-link {
  font-family: 'sofiaProSemiBold', sans-serif;
  font-size: 14px;
  color: #ff6f3c !important;
  text-decoration: none;
  font-weight: 600;
  margin-left: 4px;
  transition: color 0.3s ease;
}

.login-link:hover {
  color: #c43d0e !important;
  text-decoration: underline;
}

/* Snackbar styles */
.snackbar-text {
  font-family: 'sofiaProMedium', sans-serif;
  font-size: 13.5px;
}

.close-snack-btn {
  background: rgba(255, 255, 255, 0.08) !important;
}

/* Vuetify text field overrides using Deep Selectors */
::v-deep .custom-text-field.v-text-field--outlined > .v-input__control > .v-input__slot {
  background: rgba(255, 245, 240, 0.8) !important;
  border-radius: 12px !important;
  min-height: 48px !important;
  transition: background 0.3s ease, box-shadow 0.3s ease;
}

::v-deep .custom-text-field.v-text-field--outlined > .v-input__control > .v-input__slot:hover {
  background: rgba(255, 245, 240, 0.95) !important;
}

::v-deep .custom-text-field.v-text-field--outlined fieldset {
  border-color: rgba(255, 111, 60, 0.2) !important;
  border-width: 1.5px !important;
  border-radius: 12px !important;
  transition: border-color 0.2s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

::v-deep .custom-text-field.v-text-field--outlined.v-input--is-focused fieldset {
  border-color: #ff6f3c !important;
  border-width: 1.5px !important;
  box-shadow: 0 0 10px rgba(255, 111, 60, 0.2);
}

::v-deep .custom-text-field.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) fieldset:hover {
  border-color: rgba(255, 111, 60, 0.5) !important;
}

::v-deep .custom-text-field input::placeholder {
  color: #7a6b66 !important;
  font-weight: 400;
  opacity: 0.85;
}

::v-deep .custom-text-field input {
  color: #301b14 !important;
  font-family: 'sofiaProRegular', sans-serif !important;
  font-size: 14.5px !important;
}

::v-deep .custom-text-field .v-icon {
  color: #665551 !important;
  transition: color 0.3s ease;
}

::v-deep .custom-text-field.v-input--is-focused .v-icon {
  color: #ff6f3c !important;
}
</style>